import { differenceInDays, getYear } from 'date-fns';

export function getDayName(dateStr, locale) {
  let date = new Date(dateStr);
  return date.toLocaleDateString(locale, { weekday: 'long' });
}

export function getDayNameShort(dateStr, locale) {
  let date = new Date(dateStr);
  return date.toLocaleDateString(locale, { weekday: 'short' });
}

export function getDatesDiffDays(date1, date2) {
  const diffTime = Math.abs(date2 - date1);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function getNumberOfDaysInConcern(date1, date2) {
  return Math.abs(differenceInDays(date1, date2)) + 1;
}

export function isDaysEqual(date1, date2) {
  return (
    date1.getDate() === date2.getDate() && getYear(date1) === getYear(date2) && date1.getMonth() === date2.getMonth()
  );
}

export function getDateOfISOWeek(w, y) {
  const simple = new Date(y, 0, 1 + (w - 1) * 7);
  const dow = simple.getDay();
  const ISOweekStart = simple;
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  return ISOweekStart;
}
